<!--  -->
<template>
    <div class="business-content-main" v-loading="loading">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="tab-item-ctn">
            <div class="search-ctn">
                <div class="search-ctn-left">
                    <el-button
                        v-if="permission.print"
                        size="small"
                        title="打印出库单，部分出仓及全部出仓的单据"
                        icon="el-icon-printer"
                        class="search-btn btn-primary"
                        @click="print()"
                        >{{ permission.print }}</el-button
                    >
                    <el-button size="small" icon="el-icon-s-data" class="search-btn btn-primary" @click="showCount">合计</el-button>
                </div>
                <div class="search-ctn-right">
                    <div class="search-name">仓库</div>
                    <el-select v-model="searchData.SId" class="search-item" size="small" filterable clearable remote @visible-change="getWarehouse()">
                        <el-option v-for="optionItem in warehouseList" :label="optionItem.WarehouseName" :value="optionItem.WarehouseId" v-bind:key="optionItem.index"
                            ><span style="float: left">{{ optionItem.WarehouseName }}</span>
                            <span v-if="optionItem.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span></el-option
                        >
                    </el-select>
                    <div class="search-name">订单来源</div>
                    <el-select
                        class="search-item"
                        size="small"
                        v-model="searchData.Sources"
                        remote
                        filterable
                        allow-create
                        clearable
                        placeholder="请输入订单来源"
                        @clear="sourceClear"
                        @visible-change="visibleSourcesData"
                        :remote-method="querySourcesSearch"
                        v-select-scroll-more="searchSourcesLoad"
                    >
                        <el-option v-for="item in sourcesOptions" :key="item.FirstLetter" :label="item.Sources" :value="item.Sources"> </el-option>
                        <el-option v-if="searchLoading" disabled value="" style="text-align: center">
                            加载中
                            <i class="el-icon-loading"></i>
                        </el-option>
                    </el-select>
                    <div class="search-name">供应商</div>
                    <el-select
                        class="search-item"
                        size="small"
                        v-model="searchData.Keyword"
                        remote
                        filterable
                        allow-create
                        clearable
                        placeholder="请输入供应商名称"
                        @visible-change="querySearch()"
                        :remote-method="querySearch"
                        v-select-scroll-more="searchSupplierLoad"
                    >
                        <el-option v-for="item in supplierOptions" :key="item.EntpCusId" :label="item.EntpCusName" :value="item.EntpCusName"> </el-option>
                        <el-option v-if="searchLoading" disabled value="" style="text-align: center">
                            加载中
                            <i class="el-icon-loading"></i>
                        </el-option>
                    </el-select>
                    <div class="search-name">采购单号</div>
                    <el-input class="search-item" size="small" v-model.trim="searchData.OrderCode" v-filter-special-char="searchData.OrderCode" placeholder="单号"></el-input>
                    <div class="search-name">物流状态</div>
                    <el-select class="search-item" size="small" v-model="searchData.State">
                        <el-option v-for="item in stateList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                    </el-select>
                    <div class="search-name">提交时间</div>
                    <i class="el-icon-date search-name time-btn" @click="timeVisible = true"></i>
                    <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                    <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                </div>
            </div>
            <div class="table-ctn">
                <el-table
                    :header-cell-style="{ background: '#F2F6FC' }"
                    :data="tableData"
                    ref="multipleTable"
                    @selection-change="handleSelectionChange"
                    border=""
                    style="width: 100%"
                    @cell-dblclick="handleDBClick"
                    :tableCode="tableCode"
                    :row-key="getRowKeys"
                    :summary-method="getSummaries"
                    show-summary
                >
                    <el-table-column type="selection" reserve-selection width="50"></el-table-column>
                    <template v-for="(col,index) in columnShowSets">
                        <el-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :label="col.ColumnName"
                            resizable
                            :sortable="col.IsSort?'custom':false"
                            header-align
                            :prop="col.ColumnCode"
                            v-if="col.ColumnCode == 'OrderCode'"
                            show-overflow-tooltip
                        >
                            <template slot-scope="scope">
                                <el-badge :value="'打印' + scope.row.PrintedCount + '次'" class="mark" type="danger" v-if="scope.row.PrintedCount > 0">
                                    {{ scope.row.OrderCode }}
                                </el-badge>
                                {{ scope.row.PrintedCount > 0 ? '' : scope.row.OrderCode }}
                            </template>
                        </el-table-column>
                        <el-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :label="col.ColumnName"
                            resizable
                            :sortable="col.IsSort?'custom':false"
                            header-align
                            :prop="col.ColumnCode"
                            v-else-if="col.ColumnCode == 'InWarehouseStateName'"
                            show-overflow-tooltip
                        >
                            <template slot-scope="scope">
                                <i v-if="scope.row.InWarehouseStateName == '已入仓'" class="in-active">{{ scope.row.InWarehouseStateName }}</i>
                                <i v-else>{{ scope.row.InWarehouseStateName }}</i></template
                            >
                        </el-table-column>
                        <el-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :label="col.ColumnName"
                            resizable
                            :sortable="col.IsSort?'custom':false"
                            header-align
                            :prop="col.ColumnCode"
                            show-overflow-tooltip
                            v-else
                        >
                        </el-table-column>
                    </template>
                    <el-table-column fixed="right" label="操作" :autoWidth="true" :isCanSet="true">
                        <template slot-scope="scope">
                            <div class="ops-ctn">
                                <el-button
                                    v-if="permission.printGoodsLabels && !scope.row.IsInStorage && scope.row.WarehouseType != 1 && !isForbidBatch"
                                    title="打印商品标签"
                                    size="mini"
                                    type="text"
                                    @click="showPrintLabelsDialog(scope.row)"
                                    >{{ permission.printGoodsLabels }}</el-button
                                >
                                <el-button
                                    v-if="permission.buyIn && !scope.row.IsInStorage && scope.row.WarehouseType != 1"
                                    title="货物入仓"
                                    size="mini"
                                    type="text"
                                    @click="add(6, scope.row)"
                                    >{{ permission.buyIn }}</el-button
                                >
                                <el-button v-if="permission.checkLabels" title="查看标签" size="mini" style="color: orange" type="text" @click="showLabelDetails(scope.row)">查看标签</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination-ctn">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="searchData.page"
                    :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                    :page-size="searchData.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength"
                    v-if="tableDataLength != 0"
                ></el-pagination>
            </div>
            <el-dialog :close-on-click-modal="false" title="合计" @close="closeDialog" :visible.sync="statisticsVisible" width="500px">
                <div class="dialog-content" v-if="statisticsVisible">
                    <statistics :countData="multipleSelection" type="buy"></statistics>
                </div>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" title="创建时间" :visible.sync="timeVisible" width="800px">
                <div class="dialog-content" v-if="timeVisible">
                    <timePicker @timerSearch="timerSearch" :start="this.searchData.StartDate" :end="this.searchData.EndDate"></timePicker>
                </div>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" title="打印采购商品标签" :visible.sync="showPrintOrderDialog" width="1200px">
                <div class="dialog-content" v-if="showPrintOrderDialog">
                    <printGoodsLabels @closeDialog="closePrintLabelsDialog" :EntpPOId="orderId"></printGoodsLabels>
                </div>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" title="打印" :visible.sync="printDialogVisible" width="870px">
                <div class="dialog-content" v-if="printDialogVisible">
                    <printContent @closeDialog="closeDialog" :printId="multipleSelection[0].EntpCusPOId"></printContent>
                </div>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" title="查看标签" :visible.sync="showLabelsDialog" width="1200px" append-to-body>
                <div class="dialog-content" v-if="showLabelsDialog">
                    <checkOrderLabels @closeDialog="closeLabelsDialog" :OrderId="orderId"></checkOrderLabels>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import breadcrumb from '@/components/common/breadcrumb';
import statistics from '@/components/common/statistics.vue';
import timePicker from '@/components/common/timePicker';
import printGoodsLabels from '@/components/business/goods/printGoodsLabels.vue';
import printContent from '@/components/business/goods/printsupplierOrderIn.vue';
import checkOrderLabels from '@/components/business/purManage/checkOrderLabels.vue';
import pageLimitMixin from '@/mixins/pageLimitMixin';
import Vue from 'vue';
export default {
    mixins: [pageLimitMixin],
    name: '',
    props: ['type'],
    components: {
        statistics,
        timePicker,
        breadcrumb,
        elTableColumn,
        printGoodsLabels,
        printContent,
        checkOrderLabels
    },
    data() {
        return {
            tableCode: 'PurOrderInTable',
            loading: false,
            searchLoading: false,
            showPrintOrderDialog: false,
            orderId:'',
            timeVisible: false,
            statisticsVisible: false,
            printDialogVisible: false,
            showLabelsDialog: false,
            multipleSelection: null,
            dataIndex: 1,
            tableData: [],
            tableDataLength: 0,
            permission: {},
            stateList: [
                { Text: '全部', Value: '' },
                { Text: '未入仓', Value: '5' },
                { Text: '部分入仓', Value: '10' },
                { Text: '已入仓', Value: '15' }
            ],
            searchData: {
                Sources: '',
                Keyword: '',
                State: '5',
                OrderCode: '',
                StartDate: '',
                EndDate: '',
                SId: '',
                page: 1,
                limit: 15
            },
            columnShowSets: [],
            warehouseList: [],
            // 用于供应商列表，分页搜索功能
            supplierOptions: [],
            supplierForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            sourcesOptions: [],
            sourcesForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            isForbidBatch: false
        };
    },
    activated() {
        if (this.$store.state.needRefresh) {
            this.$store.commit('updateNeedRefresh', false);
            this.getTableData();
        }
    },
    created() {
        if (this.tableCode) this.getSetsData();
    },
    mounted() {
        this.getTableData();
        this.getConfig();
        // this.getWarehouse();
        this.$util.setEnterEvent(this, this.$route.fullPath);
        this.permission = this.$util.getPermission('purchasesOrderTakeIn');
    },
    filters: {
        stateHandle(value) {
            if (value == 5) {
                return '未提交';
            } else if (value == 10) {
                return '已提交';
            } else if (value == 15) {
                return '已完成';
            } else if (value == 20) {
                return '  已取消';
            }
        }
    },
    methods: {
        getConfig() {
            this.$util.getSysConfig('xzcgjkqbcc').then(res => {
                this.isForbidBatch = res.Result;
            });
        },
        // 记录每行的key值
        getRowKeys(row) {
            return row.EntpCusPOId;
        },
        timerSearch(timer) {
            this.timeVisible = false;
            this.searchData.StartDate = timer.start;
            this.searchData.EndDate = timer.end;
            this.handleSearch();
        },
        // 显示统计
        showCount() {
            if (this.multipleSelection) {
                this.statisticsVisible = true;
            } else {
                this.$util.warningMsg('请至少选择一条数据');
            }
        },
        closeDialog() {
            this.$refs.multipleTable.clearSelection();
            this.multipleSelection = null;
            this.statisticsVisible = false;
            this.printDialogVisible = false;
        },
        // 勾选统计
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        // 获取采购入仓列表
        getTableData() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpPurchaseOrder/GetEntpPurOrderInWarehouseList',
                    data: this.searchData,
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    if (!data) data = [];
                    this.tableData = data;
                    this.tableDataLength = res.count;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        resetSearch() {
            this.searchData = {
                Sources: '',
                Keyword: '',
                State: '5',
                OrderCode: '',
                StartDate: '',
                EndDate: '',
                SId: '',
                page: 1,
                limit: this.commonPageSize
            };
            this.querySearch('');
            this.$refs.multipleTable.clearSelection();
        },
        // 跳转编辑
        add(type, item) {
            // let searchParams = this.searchData;
            // Vue.set(searchParams, "dataIndex", "buyIn");
            // this.$util.setLocalStorage("searchParams", searchParams); //保存当前查询参数，返回页面时使用
            let id = item ? item.EntpCusPOId : '';
            this.$router.push(`/inventoryManage/purchasesOrder/takeIn/edit?type=${type}&id=${id}`);
        },
        handleSearch() {
            this.$refs.multipleTable.clearSelection();
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        //表单双击事件
        handleDBClick(event) {
            if (event) {
                this.add(1, event);
            }
        },
        // 获取供应商列表
        querySearch(key) {
            this.searchLoading = true;
            if (![undefined].includes(key)) {
                this.supplierForm.Page = 1;
                this.supplierForm.stopLoad = false;
                this.supplierForm.key = key;
                this.supplierOptions = [];
            }
            if (this.supplierForm.stopLoad) return;
            this.$util.searchSupplier(this.supplierForm.key, this.supplierForm.Page, this.supplierForm.Limit).then(data => {
                if (!data) return;
                this.supplierForm.stopLoad = data.length < this.supplierForm.Limit;
                this.supplierOptions = this.$util.uniqueArr(this.supplierOptions, data);
                this.searchLoading = false;
            });
        },
        sourceClear() {
            this.sourcesForm.Page = 1;
            this.sourcesForm.stopLoad = false;
            this.sourcesForm.key = '';
            this.sourcesOptions = [];
        },
        // 供应商列表，加载更多
        searchSupplierLoad() {
            this.supplierForm.Page += 1;
            this.querySearch();
        },
        visibleSourcesData(isShow) {
            if (isShow) {
                this.searchLoading = true;
                this.sourcesForm.Page = 1;
                this.sourcesForm.stopLoad = false;
                this.sourcesOptions = [];

                let i = this.sourcesOptions.findIndex(item => {
                    if (item.Sources == '新品采购') {
                        return true;
                    }
                });
                if (i == -1) {
                    let s1 = { Sources: '新品采购', FirstLetter: 'XPCG' };
                    this.sourcesOptions.push(s1);
                }
                let j = this.sourcesOptions.findIndex(item => {
                    if (item.Sources == '库存采购') {
                        return true;
                    }
                });
                if (j == -1) {
                    let s2 = { Sources: '库存采购', FirstLetter: 'KCCG' };
                    this.sourcesOptions.push(s2);
                }

                this.$util.searchPurOrderSources(this.sourcesForm.key, this.sourcesForm.Page, this.sourcesForm.Limit).then(data => {
                    this.searchLoading = false;
                    if (!data) return;
                    this.sourcesForm.stopLoad = data.length < this.sourcesForm.Limit;
                    this.sourcesOptions = this.$util.uniqueArr(this.sourcesOptions, data);
                });
            }
        },
        querySourcesSearch(key) {
            this.searchLoading = true;
            if (![undefined].includes(key)) {
                this.sourcesForm.Page = 1;
                this.sourcesForm.stopLoad = false;
                this.sourcesForm.key = key;
                this.sourcesOptions = [];
            }

            if ([undefined].includes(key) && this.sourcesForm.Page == 1) {
                let i = this.sourcesOptions.findIndex(item => {
                    if (item.Sources == '新品采购') {
                        return true;
                    }
                });
                if (i == -1) {
                    let s1 = { Sources: '新品采购', FirstLetter: 'XPCG' };
                    this.sourcesOptions.push(s1);
                }
                let j = this.sourcesOptions.findIndex(item => {
                    if (item.Sources == '库存采购') {
                        return true;
                    }
                });
                if (j == -1) {
                    let s2 = { Sources: '库存采购', FirstLetter: 'KCCG' };
                    this.sourcesOptions.push(s2);
                }
            } else if (![undefined].includes(key)) {
                if ('新品采购'.indexOf(key) !== -1 || 'XPCG'.indexOf(key.toUpperCase()) !== -1) {
                    let s1 = { Sources: '新品采购', FirstLetter: 'XPCG' };
                    this.sourcesOptions.push(s1);
                }
                if ('库存采购'.indexOf(key) !== -1 || 'KCCG'.indexOf(key.toUpperCase()) !== -1) {
                    let s2 = { Sources: '库存采购', FirstLetter: 'KCCG' };
                    this.sourcesOptions.push(s2);
                }
            }

            if (this.sourcesForm.stopLoad) {
                this.searchLoading = false;
                return;
            }
            this.$util.searchPurOrderSources(this.sourcesForm.key, this.sourcesForm.Page, this.sourcesForm.Limit).then(data => {
                this.searchLoading = false;
                if (!data) return;
                this.sourcesForm.stopLoad = data.length < this.sourcesForm.Limit;
                this.sourcesOptions = this.$util.uniqueArr(this.sourcesOptions, data);
            });
        },
        searchSourcesLoad() {
            if (!this.sourcesForm.stopLoad) {
                this.sourcesForm.Page += 1;
                this.querySourcesSearch();
            }
        },
        //关闭订单弹出层
        closePrintLabelsDialog() {
            this.orderId = '';
            this.showPrintOrderDialog = false;
        },
        // 打印
        showPrintLabelsDialog(row) {
            if (row) {
                this.orderId = row.EntpCusPOId;
                this.showPrintOrderDialog = true;
            } else {
                this.$util.warningMsg('请选择采购入仓单进行打印');
                return;
            }
        },
        getWarehouse() {
            if (this.warehouseList == 0) {
                this.$util.getWarehouse().then(data => {
                    this.warehouseList = data;
                });
            }
        },
        print() {
            let that = this;
            if (!that.multipleSelection || that.multipleSelection.length == 0) {
                that.$util.warningMsg('请选择一张采购入库单打印');
                return;
            } else if (that.multipleSelection.length > 1) {
                that.$util.warningMsg('只能选择一张采购入库单打印');
                return;
            }
            if (that.multipleSelection[0].InWarehouseStateName == '未入仓') {
                that.$util.warningMsg('不能打印未出仓的采购入库单');
                return;
            }

            //验证是否只有一条出库单的数据：同一天里，全部入仓 ；如果分为两天的，就要跳转到新的页面
            that.$util.VerOrderInOutRecords(that.multipleSelection[0].EntpCusPOId).then(data => {
                if (data === 1) {
                    that.printDialogVisible = true;
                } else if (data > 1) {
                    that.$router.push(
                        '/inventoryManage/printInOutOrder?id=' +
                            that.multipleSelection[0].EntpCusPOId +
                            '&cusName=' +
                            that.multipleSelection[0].EntpCusName +
                            '&orderCode=' +
                            that.multipleSelection[0].OrderCode
                    );
                } else that.$util.warningMsg('选择的采购入库单打印异常，请刷新后重新操作');
            });
        },
        getSetsData() {
            this.columnShowSets = [];
            this.$util.getTBSetsForShow(this.tableCode).then(data => {
                data.forEach(item => {
                    let colums = {
                        IsShow: item.IsShow,
                        Width: item.Width,
                        ColumnName: item.ColumnName,
                        ColumnCode: item.ColumnCode,
                        SortNum: item.SortNum,
                        IsSort: item.IsSort
                    };

                    this.columnShowSets.push(colums);
                });
            });
        },
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }
                if (column.property == 'SName' || column.property == 'PayTypeName') {
                    sums[index] = '';
                    return;
                }
                const values = data.map(item => Number(item[column.property]));
                if (!values.every(value => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);
                    let strL = sums[index] + '';
                    if (strL.indexOf('.') > -1) {
                        let str = strL.split('.')[1];
                        if (str.length > 2) {
                            sums[index] = sums[index].toFixed(2);
                        }
                    }
                } else {
                    sums[index] = '';
                }
            });

            return sums;
        },
        //关闭订单弹出层
        closeLabelsDialog() {
            this.orderId = '';
            this.showLabelsDialog = false;
        },
        // 打印
        showLabelDetails(row) {
            if (row) {
                this.orderId = row.EntpCusPOId;
                this.showLabelsDialog = true;
            } else {
                this.$util.warningMsg('请选择单据进行查看');
                return;
            }
        },
    }
};
</script>
<style lang="less" scoped>
.el-button-hover {
    color: #409eff;
    border-color: #c6e2ff;
    background-color: #ecf5ff;
}
@media screen and (min-width: 1830px) {
    .table-ctn {
        height: calc(100% - 50px);
        overflow-y: auto;
    }
}
@media screen and (max-width: 1830px) {
    .table-ctn {
        height: calc(100% - 50px);
        overflow-y: auto;
    }
}
/deep/.is-fixed {
    top: 10px;
}
</style>
